// extracted by mini-css-extract-plugin
export default {"left":"TVPageLeft_left__a-p62"};